export default __webpack_public_path__ + "static/media/pogo-back-img.1444c1ce.png";